import { addPassiveEventListener as J, buildSvg as oe, detectSwipe as K, DIRECTIONS as L } from "../../util/dom-utils.js";
import { createCloseButton as T } from "../../util/component-utils.js";
import { isTransparent as te, toRgba as ae } from "../../util/color-utils.js";
import FullScreenMessage from "../models/full-screen-message.js";
import HtmlMessage from "../models/html-message.js";
import InAppMessage from "../models/in-app-message.js";
import ModalMessage from "../models/modal-message.js";
import SlideUpMessage from "../models/slide-up-message.js";
import { logInAppMessageClick } from "../log-in-app-message-click.js";
import { _handleBrazeAction as O } from "../../Core/handle-braze-action.js";
import ct from "./html-message-to-html.js";
import ne from "./modal-utils.js";
import { logger as E, Guid as P } from "../../../shared-lib/index.js";
import { KeyCodes as ie } from "../../util/key-codes.js";
export default function le(e, o, t, a, n, i) {
  var s = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : document.body;
  var m = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : "ltr";
  if (e.Qe = document.activeElement, e instanceof HtmlMessage) return ct(e, o, a, n, i);
  var l = function (e, o, t, a, n) {
    var i = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : document.body;
    var s = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : "ltr";
    var m = null;
    var l = document.createElement("div");
    l.dir = s, l.className = "ab-in-app-message ab-start-hidden ab-background", n && (l.style.zIndex = (n + 1).toString()), e.Ve() && (l.className += " ab-modal-interactions", l.setAttribute("tabindex", "-1")), e.Oe() || (l.style.color = ae(e.textColor), l.style.backgroundColor = ae(e.backgroundColor), te(e.backgroundColor) && (l.className += " ab-no-shadow"));
    var c = function c() {
        -1 !== l.className.indexOf("ab-start-hidden") && (l.className = l.className.replace("ab-start-hidden", ""), document.querySelectorAll(".ab-iam-img-loading").length > 0 ? t("Cannot show in-app message ".concat(e.message, " because another message is being shown."), InAppMessage.Ye.We) : o(l));
      },
      r = function r() {
        var o = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
        var t = document.querySelectorAll(".ab-iam-root");
        t && 0 !== t.length || (t = i.querySelectorAll(".ab-iam-root")), t && t.length > 0 && (t[0].classList.remove("ab-iam-img-loading"), m && (clearTimeout(m), m = null), o ? c() : E.error("Cannot show in-app message ".concat(e.message, " because the image failed to load.")));
      };
    if (e.imageStyle === InAppMessage.ImageStyle.GRAPHIC && (l.className += " graphic"), e.orientation === InAppMessage.Orientation.LANDSCAPE && (l.className += " landscape"), null != e.buttons && 0 === e.buttons.length) {
      e.clickAction !== InAppMessage.ClickAction.NONE && (l.className += " ab-clickable");
      var _o = function _o(o) {
        return e.ll(l, function () {
          logInAppMessageClick(e), e.clickAction === InAppMessage.ClickAction.URI && O(e.uri || "", a || e.openTarget === InAppMessage.OpenTarget.BLANK, o);
        }), o.stopPropagation(), !1;
      };
      l.onclick = _o, l.addEventListener("keydown", function (e) {
        if (e.keyCode === ie.Ze || e.keyCode === ie.lo) return _o(e);
      });
    }
    var d = T("Close Message", e.Oe() ? void 0 : ae(e.closeButtonColor), function () {
      e.ll(l);
    }, s);
    l.appendChild(d), n && (d.style.zIndex = (n + 2).toString());
    var u = document.createElement("div");
    u.className = "ab-message-text", u.dir = s, u.setAttribute("role", "article");
    var b = (e.messageAlignment || e["do"]).toLowerCase();
    u.className += " " + b + "-aligned";
    var f = !1;
    var p = document.createElement("div");
    if (p.className = "ab-image-area", e.imageUrl) {
      var _o2 = document.createElement("img");
      if (_o2.setAttribute("src", e.imageUrl), e.bo(_o2), 0 === document.querySelectorAll(".ab-iam-img-loading").length) {
        f = !0;
        var _e = document.querySelectorAll(".ab-iam-root");
        _e && _e.length > 0 && _e[0].classList.add("ab-iam-img-loading"), m = window.setTimeout(function () {
          r(!1);
        }, 6e4), _o2.onload = function () {
          r();
        }, _o2.onerror = function () {
          r(!1);
        };
      }
      if (e.cropType === InAppMessage.CropType.CENTER_CROP) {
        var _e2 = document.createElement("div");
        _e2.className = "ab-center-cropped-img", _e2.appendChild(_o2), p.appendChild(_e2);
      } else p.appendChild(_o2);
      l.appendChild(p), u.className += " ab-with-image";
    } else if (e.icon) {
      p.className += " ab-icon-area";
      var _o3 = document.createElement("span");
      _o3.className = "ab-icon", e.Oe() || (_o3.style.backgroundColor = ae(e.iconBackgroundColor), _o3.style.color = ae(e.iconColor));
      var _t = document.createElement("i");
      _t.className = "fa", _t.appendChild(document.createTextNode(e.icon)), _t.setAttribute("aria-hidden", "true"), _o3.appendChild(_t), p.appendChild(_o3), l.appendChild(p), u.className += " ab-with-icon";
    }
    if (J(u, "touchstart"), e.header && e.header.length > 0) {
      var _o4 = document.createElement("h1");
      _o4.className = "ab-message-header", e.po = P.oe(), _o4.id = e.po;
      var _t2 = (e.headerAlignment || InAppMessage.TextAlignment.CENTER).toLowerCase();
      _o4.className += " " + _t2 + "-aligned", e.Oe() || (_o4.style.color = ae(e.headerTextColor)), _o4.appendChild(document.createTextNode(e.header)), u.appendChild(_o4);
    }
    var g = e.ho();
    return u.appendChild(g), l.appendChild(u), f || c(), e.Pe = l, l;
  }(e, o, t, a, n, s, m);
  if (e instanceof FullScreenMessage || e instanceof ModalMessage) {
    var _o5 = e instanceof FullScreenMessage ? "ab-fullscreen" : "ab-modal";
    l.className += " ".concat(_o5, " ab-centered"), ne.jo(e, l, a), ne.wo(l), ne.vo(e.po, l);
  } else if (e instanceof SlideUpMessage) {
    l.className += " ab-slideup", l.setAttribute("tabindex", "0"), l.setAttribute("role", "alert");
    var _o6 = l.getElementsByClassName("ab-close-button")[0];
    if (null != _o6) {
      var _t3 = oe("0 0 11.38 19.44", "M11.38 9.72l-9.33 9.72L0 17.3l7.27-7.58L0 2.14 2.05 0l9.33 9.72z", e.Oe() ? void 0 : ae(e.closeButtonColor));
      _t3.setAttribute("class", "ab-chevron ".concat(m)), _o6.appendChild(_t3);
    }
    var _t4, _a;
    K(l, L.Zt, function (e) {
      l.className += " ab-swiped-left", null != _o6 && null != _o6.onclick && _o6.onclick(e);
    }), K(l, L.ae, function (e) {
      l.className += " ab-swiped-right", null != _o6 && null != _o6.onclick && _o6.onclick(e);
    }), e.slideFrom === InAppMessage.SlideFrom.TOP ? (_t4 = L.ko, _a = " ab-swiped-up") : (_t4 = L.xo, _a = " ab-swiped-down"), K(l, _t4, function (e) {
      l.className += _a, null != _o6 && null != _o6.onclick && _o6.onclick(e);
    });
  }
  return l;
}